import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const rootElement = document.getElementById('root');

const appComponent = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  // Si react-snap ya dejó HTML inyectado, lo hidratamos
  ReactDOM.hydrateRoot(rootElement, appComponent);
} else {
  // Si está vacío (como en desarrollo local), creamos el root y renderizamos normal
  const root = ReactDOM.createRoot(rootElement);
  root.render(appComponent);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
